import { Injectable } from '@angular/core';
import { ProductCaptureData } from '../model/interfaces/product-capture.interface';
import { DateUtils } from 'src/app/utils/date.utils';

@Injectable({
  providedIn: 'root',
})
export class OverviewService {
  constructor() {}

  getLifecycleTimelineData(data: ProductCaptureData): Array<any> {
    const { keyDates } = data.summary;

    const timelineData = [
      {
        label: 'Today',
        date: new Date().toISOString() as string,
      },
      {
        label: 'Issue Date',
        date:
          typeof keyDates.issueDate.value === 'string'
            ? keyDates.issueDate.value
            : DateUtils.getStringFromDateObject(keyDates.issueDate.value),
      },
      {
        label: 'Redemption Date',
        date:
          typeof keyDates.redemptionDate.value === 'string'
            ? keyDates.redemptionDate.value
            : DateUtils.getStringFromDateObject(keyDates.redemptionDate.value),
      },
      {
        label: 'Initial Obs. Date',
        date:
          typeof keyDates.initialObservationDate.value === 'string'
            ? keyDates.initialObservationDate.value
            : DateUtils.getStringFromDateObject(keyDates.initialObservationDate.value),
      },
      {
        label: 'Final Obs. Date',
        date:
          typeof keyDates.finalObservationDate.value === 'string'
            ? keyDates.finalObservationDate.value
            : DateUtils.getStringFromDateObject(keyDates.finalObservationDate.value),
      },
    ];
    const filteredData = timelineData.filter((data) => data.date);
    const sortedData = filteredData.sort(
      (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()
    );

    const labelsBecomeArrayOfLabels = sortedData.map((obj, i) => {
      (obj.label as any) = [obj.label];
      obj.date =
        typeof obj.date === 'string'
          ? obj.date.substring(0, 10)
          : obj.date['value'];
      return obj;
    });

    const labelArraysPopulatedWithMatchingDateEntries =
      labelsBecomeArrayOfLabels.map((element, index, array) => {
        let i = array.findIndex((dup) => dup.date === element.date);
        if (i !== index) {
          let a = array[i].label as any;
          a.push(element.label[0]);
          element.date = null;
          element.label = null;
        }
        return element;
      });

    const filteredDataWithDuplcateDatesRemoved =
      labelArraysPopulatedWithMatchingDateEntries.filter(
        (obj) => obj.date !== null && obj.label !== null
      );

    return filteredDataWithDuplcateDatesRemoved;
  }
}
